import PowerIndependence from 'elem/compPage/PowerIndependence';
import dynamic from 'next/dynamic';
import { useGlobal } from '@/utils/useGlobal';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';

export default function PowerIndependencePage({ SEO }: any) {
    const { useRouter, useEffect, useLang } = useGlobal();
    const { t } = useLang('powerindependence');
    const router = useRouter();
    const { locale } = router;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });
    const WHITE_SITE = ['de', 'fr', 'eu', 'uk', 'it', 'es'];

    useEffect(() => {
        if (!WHITE_SITE.includes(locale)) {
            router.push('/404');
        }
    }, []);

    return (
        <PageLayout isNoFixed hideToTop>
            <SEO title={t('seo_title')} description={t('seo_desc')} />
            <SEOlinksA locale={String(locale)} list={WHITE_SITE} pathname={'power-independence'} />
            <GtmPageLoad />
            <PowerIndependence />
        </PageLayout>
    );
}
